module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921075334_T.4998d5f0.jpg";